// extracted by mini-css-extract-plugin
export default {"form":"MealForm_form__New+J"};